export default {
    computed:{
        currencyFormat(){
            return v => (v !== null && v >= 0) ? v.toLocaleString('es-AR', {style:'currency', currency:'ARS'}).replace(',00','') : v
        }
    }
}
